import React, { useState } from "react";
import { ChevronRightIcon, BrainIcon } from "lucide-react";
import { cn } from "../../../lib/utils";
import { parseReasoning, ReasoningData } from "../../../utils/reasoningTags";

export type ReasoningContent = ReasoningData;

interface ReasoningDisplayProps {
  reasoning: ReasoningContent;
  className?: string;
  defaultExpanded?: boolean;
}

export const parseReasoningFromContent = parseReasoning;

const ReasoningDisplay: React.FC<ReasoningDisplayProps> = ({
  reasoning,
  className,
  defaultExpanded = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const entries = Object.entries(reasoning);
  if (entries.length === 0) {
    return null;
  }

  return (
    <div className={cn("rounded-lg border border-maitai-green/30 bg-maitai-green/5", className)}>
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center gap-2 w-full px-3 py-2 text-left hover:bg-maitai-green/10 transition-colors rounded-t-lg"
      >
        <ChevronRightIcon
          className={cn(
            "w-4 h-4 text-maitai-green transition-transform duration-200",
            isExpanded && "rotate-90"
          )}
        />
        <BrainIcon className="w-4 h-4 text-maitai-green" />
        <span className="text-sm font-gc-med text-maitai-green">Reasoning</span>
        <span className="text-xs text-muted-foreground ml-auto">
          {entries.length} field{entries.length !== 1 ? "s" : ""}
        </span>
      </button>

      {isExpanded && (
        <div className="px-4 pb-3 pt-1 space-y-2 animate-in slide-in-from-top-1 duration-200">
          {entries.map(([key, value]) => (
            <div key={key} className="flex gap-2 text-sm">
              <span className="font-gc-med text-foreground min-w-[100px] shrink-0">
                {key}:
              </span>
              <span className="text-muted-foreground whitespace-pre-wrap break-words">
                {value}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReasoningDisplay;
